// extracted by mini-css-extract-plugin
export default {"form-control":"Input_form-control__ezaO8","invalid":"Input_invalid__eWAKO"};